import React, { Component } from 'react';
import { Button, Grid,  Menu, Dropdown} from 'semantic-ui-react';
    // FONT
    const fontFamily={
      fontFamily:'Raleway, Microsoft JhengHei, sans-serif',
      fontWeight: 200,
    }
    const fontResize={
      ...fontFamily,
      fontSize:'0.75em',
    }
    
    // Style
    const divStyle={
      margin: 0,
    }

    const menuStyle= {
      ...fontFamily,
      position: 'absolute',
      width: '100%',
      display: 'flex', 
      justifyContent: 'center',
      margin: 0,
      item:{
        ...fontFamily,
        margin: '1em',
        width: '100%',
        color: 'white',
      },
      itemSwitch:{
        width: '100%',
        color: 'white',
        itemL:{
          ...fontFamily,
          margin: '1em 0 1em 1em',
        },
        itemC:{
          ...fontFamily,
          margin: '1em 0 1em 0em',
        },
        itemR:{
          ...fontFamily,
          margin: '1em 1em 1em 0',
        }
      },
    };
    const footStyle= {
      position: 'absolute',
      width: '100%',
      display: 'flex', 
      justifyContent: 'center',
      bottom: '1em',
      item:{
        margin: '0em 1em -1em 1em',
      },
      seg:{
        margin: 0,
        color: 'rgba(255,100,90,1)'
      },
      span:{
        margin: '0em 0.5em 0.5em 0.5em',
    }
    };
    // RESIZE
    const divStyleResize={
      margin: 0,

    }
    const menuStyleResize= {
      ...fontResize,
      position: 'absolute',
      width:'90%',
      bottom: '1.5em',
      left: '5%',
      backgroundColor: 'rgba(255,100,90,0)',
      border: 'none',
      boxShadow: 'none',
      drop:{
        ...fontResize,
        color:'white',
        justifyContent: 'center',
        margin:'0.25em 0 0 0',
        backgroundColor: 'rgba(255,100,90,0)',
        border: 'rgba(255,100,90,1) solid 0.15em',
      },
      background:{
        margin: '0 0 1em -1em',
        backgroundColor: 'rgba(255,100,90,0)',
        border: 'none'    
      },
      item:{
        ...fontResize,
        margin: '-0.25em 0 -0.25em 0',
        color: 'white',
        width: '100%',
      },
      itemSwitch:{
        position: 'absolute',
        margin:'0.25em 0em 0 0em',
        right:'-2.5%',
        color: 'white',

        item:{
          ...fontResize,
          margin: 0,

        },
        
      },
      span:{
        position: 'absolute',
        margin:'0.25em -1.5em 0 -1.5em',
      },
    };
    /*
    const options = [
      { key: 'about', text: 'About', value: 'about'},
      { key: 'service', text: 'Service', value: 'service'},
      { key: 'gallery', text: 'Gallery', value: 'gallery' },
      { key: 'lab', text: 'Lab', value: 'lab' },
      { key: 'contact', text: 'Contact', value: 'contact' },
    ];
    */


export default class MenuButtonBar extends Component {
  constructor(props) {
      super(props);
  };
  
  state = { 
    activeItem: 'about',
    activeLang: 'en',
  }/*
  componentWillReceiveProps({resize}) {
    this.setState({resize: resize});
  }*/
  // Method
  handleItemClick = (e, { name }) => {
    this.setState({ activeItem: name });
    this.props.listenMBB(name);
  }
  handleLangClick = (e, { name }) => {
    if (name==='toggle'){
        var nv = (this.state.activeLang === 'en' ? 'tw' : 'en'); 
        this.setState({ activeLang: nv });
        this.props.listenLANG(nv);
    }else{
        this.setState({ activeLang: name });
        this.props.listenLANG(name);
    }
  }
  // render
  render() {
      const { activeItem } = this.state;
      const { activeLang } = this.state;
      const { activeTab } = this.state;

      const dropText = ()=>{
          switch(this.state.activeItem){
            case 'about':
                return (this.state.activeLang === 'en' ? 'About' : '關於');
            case 'service':
                return (this.state.activeLang === 'en' ? 'Service' : '服務');
            case 'gallery':
                return (this.state.activeLang === 'en' ? 'Gallery' : '作品');
            case 'lab':
                return (this.state.activeLang === 'en' ? 'Lab' : '分享');
            case 'contact':
                return (this.state.activeLang === 'en' ? 'Contact' : '聯繫');
          }  
      }  
      if (this.props.resize){
        return(
          <div style={divStyleResize}>
            <Menu size='massive' style={menuStyleResize} >
              <Menu.Menu position='left'>
              <Dropdown color='red' inverted button upward text={dropText()} style={menuStyleResize.drop}>
                <Dropdown.Menu inverted style={menuStyleResize.background}>
                  <Dropdown.Item >
                    <Button color='red' inverted name='contact' active={activeItem === 'contact'} onClick={this.handleItemClick}style={menuStyleResize.item}>{activeLang==='en'?'Contact':'聯絡我們'}</Button>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Button color='red' inverted name='lab' active={activeItem === 'lab'} onClick={this.handleItemClick}style={menuStyleResize.item}>{activeLang==='en'?'Lab':'實驗分享'}</Button>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Button color='red' inverted name='gallery' active={activeItem === 'gallery'} onClick={this.handleItemClick}style={menuStyleResize.item}>{activeLang==='en'?'Gallery':'作品'}</Button>
                  </Dropdown.Item>
                  <Dropdown.Item>
                    <Button color='red' inverted name='service' active={activeItem === 'service'} onClick={this.handleItemClick}style={menuStyleResize.item}>{activeLang==='en'?'Service':'服務項目'}</Button>
                  </Dropdown.Item>
                  <Dropdown.Item >
                    <Button color='red' inverted name='about' active={activeItem === 'about'} onClick={this.handleItemClick}style={menuStyleResize.item}>{activeLang==='en'?'About':'關於澄之朵'}</Button>
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
              </Menu.Menu>
              <Menu.Item position='left' ><Button circular size='mini' color='red' inverted icon='facebook' style={menuStyleResize.span}/></Menu.Item>
              <Menu.Item position='left' ><Button circular size='mini' color='red' inverted icon='twitter'style={menuStyleResize.span}/></Menu.Item>
              <Menu.Item position='left' ><Button circular size='mini' color='red' inverted icon='linkedin' style={menuStyleResize.span}/></Menu.Item>
              <Menu.Item position='left' ><Button circular size='mini' color='red' inverted icon='google plus' style={menuStyleResize.span}/></Menu.Item>
              <Menu.Item position='left' >
                  <Button size='mini' circular inverted  color='red' toggle name='toggle' active={activeLang === 'en'} onClick={this.handleLangClick} style={menuStyleResize.span}>{activeLang==='en'?'En':'中'}</Button>
              </Menu.Item>
              
            </Menu>
          </div>
          );
      }else{
        return (
        <div style={divStyle}>
          <Grid centered columns={8} padded style={menuStyle}>
              <Grid.Column>
                <Button color='red' inverted name='about' active={activeItem === 'about'} onClick={this.handleItemClick}style={menuStyle.item}>{activeLang==='en'?'About':'關於澄之朵'}</Button>
              </Grid.Column>
              <Grid.Column>
                <Button color='red' inverted name='service' active={activeItem === 'service'} onClick={this.handleItemClick}style={menuStyle.item}>{activeLang==='en'?'Service':'服務項目'}</Button>
              </Grid.Column>
              <Grid.Column>
                <Button color='red' inverted name='gallery' active={activeItem === 'gallery'} onClick={this.handleItemClick}style={menuStyle.item}>{activeLang==='en'?'Gallery':'作品'}</Button>
              </Grid.Column>
              <Grid.Column>
                <Button color='red' inverted name='lab' active={activeItem === 'lab'} onClick={this.handleItemClick}style={menuStyle.item}>{activeLang==='en'?'Lab':'實驗分享'}</Button>
              </Grid.Column>
              <Grid.Column>
                <Button color='red' inverted name='contact' active={activeItem === 'contact'} onClick={this.handleItemClick}style={menuStyle.item}>{activeLang==='en'?'Contact':'聯絡我們'}</Button>
              </Grid.Column>
              <Grid.Column>
                <Button.Group style={menuStyle.itemSwitch}>
                  <Button color='red' inverted name='tw' active={activeLang === 'tw'} onClick={this.handleLangClick} style={menuStyle.itemSwitch.itemL}>中文</Button>
                  <Button.Or inverted style={menuStyle.itemSwitch.itemC}/>
                  <Button color='red' inverted name='en' active={activeLang === 'en'} onClick={this.handleLangClick} style={menuStyle.itemSwitch.itemR} >En</Button>
                </Button.Group>
              </Grid.Column>
          </Grid>
          <Grid cenered style={footStyle}>
            <Grid.Row>
              <Button circular color='red' inverted icon='facebook' style={footStyle.item}/>
              <Button circular color='red' inverted icon='twitter'style={footStyle.item}/>
              <Button circular color='red' inverted icon='linkedin' style={footStyle.item}/>
              <Button circular color='red' inverted icon='google plus'style={footStyle.item}/>
            </Grid.Row>
            <Grid.Row style={footStyle.seg}>
                <span style={footStyle.span}>&copy; CHANGE DUO STUDIO</span><span style={footStyle.span}>｜</span><span style={footStyle.span}>TEL：(02)2321-5563</span><span style={footStyle.span}>｜</span><span style={footStyle.span}>FAX：(02)2321-4317</span>
            </Grid.Row>
          </Grid>
        </div>
        );
      }
  }
}


// WEBPACK FOOTER //
// ./src/assets/component/menuButton.jsx